import { ArpeggiSupportedChain } from '@arpeggi/shared'
import { chainId } from 'wagmi'

const PROD_CHAIN_IDS: Record<ArpeggiSupportedChain, number> = {
  ethereum: chainId.mainnet,
  polygon: chainId.polygon,
  optimism: chainId.optimism
}

const DEV_CHAIN_IDS: Record<ArpeggiSupportedChain, number> = {
  ethereum: chainId.goerli,
  polygon: chainId.polygonMumbai,
  optimism: 420
}

export const getChainId = (chain: ArpeggiSupportedChain): number | undefined => {
  if (!chain) return undefined

  if (window.ENV === 'prod') return PROD_CHAIN_IDS[chain]
  return DEV_CHAIN_IDS[chain]
}
